import { render, staticRenderFns } from "./EmployeeBeneficiaryModal.vue?vue&type=template&id=451390be&scoped=true&"
import script from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451390be",
  null
  
)

export default component.exports